import '../scss/theme.scss';
import 'bootstrap';
import './header';
import './video';
import './gsap';
import './swiper';
import './product';

import mobileMenu from './utils/hcOffcanvasNav';
import lazyload from './utils/lazyload';

// import { loadGoogleMaps } from './utils/gmap/map';


document.addEventListener('DOMContentLoaded', () => {
  lazyload();
  mobileMenu('.main-navigation', '.hc-menu-toggle');
});
